import { Component, effect, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { TooltipComponent } from '../../components/tooltip/tooltip.component';
import { NewActionButtonComponent } from '../../components/new-action-button/new-action-button.component';
import { tapResponse } from '@ngrx/operators';
import { NotificationService } from 'src/services/notification.service';
import { UserService, NotificationResponse } from 'src/services/user.service';
import { GeneralStore } from 'src/store/general.store';
import { DialogHeaderComponent } from '../../components/dialog-header/dialog-header.component';

@Component({
  selector: 'app-notification-setting',
  templateUrl: './notification-setting.dialog.html',
  styleUrls: ['./notification-setting.dialog.scss'],
  host: { class: 'app-dialog-content' },
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    MatSlideToggleModule,
    FormsModule,
    MatTooltipModule,
    DialogHeaderComponent,
    TooltipComponent,
    NewActionButtonComponent,
  ],
})
export class NotificationSettingDialog {
  protected readonly dialogRef = inject(MatDialogRef<NotificationSettingDialog>);
  private readonly userService = inject(UserService);
  private readonly notificationService = inject(NotificationService);
  protected userNotificationSettings!: NotificationResponse;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected masterEmailToggle: any;
  protected userName!: string;
  private readonly generalStore = inject(GeneralStore);

  protected tooltipPosition: TooltipPosition = 'above';

  constructor() {
    effect(() => {
      const tempUserInfo = this.generalStore.userInfo();
      if (tempUserInfo) {
        this.userName = tempUserInfo.userFullName || '';
      }
    });
    this.userService.getNotificationSettings().subscribe(response => {
      this.userNotificationSettings = response;
      this.setDefaultValueSelectAll();
    });
  }

  private setDefaultValueSelectAll() {
    let hasAtLeastOneFalse = false;
    let setting: keyof NotificationResponse;
    for (setting in this.userNotificationSettings) {
      if (!this.userNotificationSettings[setting]) {
        hasAtLeastOneFalse = true;
        break;
      }
    }
    this.masterEmailToggle = !hasAtLeastOneFalse;
  }

  protected changeSelectAll() {
    if (this.masterEmailToggle === undefined || this.userNotificationSettings === undefined) {
      return;
    }
    let setting: keyof NotificationResponse;
    for (setting in this.userNotificationSettings) {
      //Convert each value to boolean
      this.userNotificationSettings[setting] = this.masterEmailToggle;
    }
    this.commitChange();
  }

  protected commitChange(): void {
    this.setDefaultValueSelectAll();
    this.userService
      .updateNotificationSettings(this.userNotificationSettings)
      .pipe(
        tapResponse({
          next: () => {
            this.notificationService.openSuccessSnackBar(
              'User notification settings have been updated.',
            );
          },
          error: () => {
            this.notificationService.openErrorSnackBar(
              'Failed to update user notification settings.',
            );
          },
        }),
      )
      .subscribe();
  }
}
